import p1 from "assets/images/posts/p1.jpg";
import p2 from "assets/images/posts/p2.jpg";
import p3 from "assets/images/posts/p3.jpg";
import PostImage from "./PostImage";

const PostMedia3 = () => {
    return (
        <div className="post-image trible-img">
            <div className="masonry-grid justify-center gap-5">
                {/* <!-- Left column --> */}
                <div className="masonry-column-left" style={{ width: "45%" }}>
                    {/* <img src={p1} alt="" /> */}
                    <PostImage img={p1} />
                </div>
                {/* <!-- Right column --> */}
                <div
                    className="masonry-column-right  flex flex-col justify-center gap-5"
                    style={{ width: "45%" }}
                >
                    <PostImage img={p2} style={{ height: "47%" }} />
                    <PostImage img={p3} style={{ height: "47%" }} />
                </div>
            </div>
        </div>
    );
};

export default PostMedia3;
